<template>
  <div>
    <v-row dense>
      <v-col cols="4">
        <v-checkbox
          v-model="form.personal_profile.receive_via_email"
          name="receive_via_email"
          :readonly="readonly"
          :label="$t('PROFILE.RECEIVE_INVOICES_VIE_EMAIL')"
          :error-messages="errors.get('personal_profile.receive_via_email')"
          @change="updateValue('receive_via_email', $event, 'personal_profile')"
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="form.personal_profile.invoice_email"
          name="invoice_email"
          :readonly="readonly"
          :label="$t('PROFILE.EMAIL_FOR_INVOICES')"
          :rules="getRulesByName('personal_profile.invoice_email')"
          :error-messages="errors.get('personal_profile.invoice_email')"
          @input="updateValue('invoice_email', $event, 'personal_profile')"
        />
      </v-col>
    </v-row>
    <v-row dense class="mt-0">
      <v-col cols="4">
        <v-checkbox
          v-model="form.without_vat"
          name="without_vat"
          :readonly="readonly"
          :label="$t('EREPORTER.INVOICES.WITHOUT_VAT')"
          :error-messages="errors.get('person.without_vat')"
          @change="updateValue('without_vat', $event, 'person')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { email, requiredEmail } from '@/modules/_global/variables/rules';

export default {
  name: 'BillingForm',

  mixins: [formEditable],

  data() {
    return {
      form: {
        without_vat: false,
        personal_profile: {
          receive_via_email: false,
          invoice_email: ''
        }
      }
    };
  },

  computed: {
    rules() {
      return {
        personal_profile: {
          invoice_email: this.form.personal_profile.receive_via_email
            ? requiredEmail
            : email
        }
      };
    }
  }
};
</script>

<style scoped></style>
